import Resource from '@/plugins/sdk/Resource'
import { BOOLEAN, DATETIME, NUMBER, INTEGER, UUID, ITEM, COLLECTION } from '@/plugins/sdk/fields'
import RateCard from '@/plugins/sdk/resources/RateCard'
import PriceBreak from './PriceBreak'
import Carrier from '@/plugins/sdk/resources/Carrier'
import Zone from '@/plugins/sdk/resources/Dictionary/Zone'
import CarrierService from '@/plugins/sdk/resources/Carrier/Service'

export default class extends Resource {
  static name = 'ratecard_rate'

  static get fields () {
    return {
      id: new UUID(),
      unit_size: new INTEGER(),
      accumulative: new INTEGER(),
      reciprocal: new INTEGER(),
      cubic: new INTEGER(),
      min_charge: new NUMBER(),
      cube_limit: new NUMBER(),
      weight_limit: new INTEGER(),
      round_weights_to: new NUMBER(),
      deleted: new BOOLEAN(),
      deleted_date: new DATETIME(),
      rate_card: new ITEM(RateCard),
      price_breaks: new COLLECTION(PriceBreak),
      carrier: new ITEM(Carrier),
      carrier_service: new ITEM(CarrierService),
      zone_to: new ITEM(Zone),
      zone_from: new ITEM(Zone)
    }
  }
}
